import React, { useEffect, useRef, useState } from "react";
import { apiCall } from "../../../../utils/axiosService";
import { API_URL } from "../../../../utils/apiRoutes";
import { apiResponse } from "../../../../utils/apiResponse";
import { Button, Col, Row, Table } from "react-bootstrap";
import { commonService } from "../../../../utils/commonService";
import Loader from "../../../Loader/Loader";
import { Bar } from "react-chartjs-2";
import {
    Chart,
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend,
    PointElement,
    LineElement,
} from "chart.js";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import emailIcon from "../../../../Assets/Images/Email.svg";
import moment from "moment";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { compName } from "../../../../utils/constant";
import { MultiSelect } from "primereact/multiselect";
const RevenueByMarketSegment = ({
    setCompDataFromChild,
    rowIndex,
    colIndex,
    api,
    para,
    setting,
}) => {
    const defaultStatusSelected = [ "I", "O", "R" ]

    const initStatusList = [
        { label: "Check-in (I)", value: "I" },
        { label: "Check-Out (O)", value: "O" },
        { label: "Reserved (R)", value: "R" },
        { label: "Cancelled (C)", value: "C" },
        { label: "No Show (N)", value: "N" }
    ]
    const multiselectRef = useRef(null);
    const [selectedTempStatus, setSelectedTempStatus] = useState(defaultStatusSelected);
    const [selectedStatus, setSelectedStatus] = useState(defaultStatusSelected);
    const [revData, setRevData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [chartData, setChartData] = useState(null);
    const widgetDetailRef = useRef();
    const { snapshottitle, propertyCode, snapshotId } = useParams();
    const defaultAsOfDateFromRTK = useSelector(
        (store) => store.headerProperty.defaultAsOfDate
    );
    const getRevData = async () => {
        setLoading(true);
        let revDataResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.CRM_SNAPSHOT.REVENUE_BY_MARKETSEGMENT,
                body: { 
                    propertyCode: para?.propertyCode,
                    AsOfDate: para?.asOfDate,
                    Status: selectedStatus && selectedStatus.length > 0 ? selectedStatus.join(",") : ""
                },
            },
            false
        );

        let response = apiResponse(false, revDataResponse);

        if (response?.isValidate) {
            let totalRoomSold = {
                label: "Total Room Sold",
                data: [],
                backgroundColor: "#4F98CA",
                stack: "Stack 2",
                type: "bar",
                order: 1,
            };
            let totalRevenue = {
                label: "Total Revenue",
                data: [],
                backgroundColor: "#3EB978",
                stack: "Stack 1",
                type: "bar",
                order: 1,
            };
            let labels = [];
            response?.data?.data?.forEach((item) => {
                labels = [...labels, item?.MarketSegment];
                totalRoomSold.data = [...totalRoomSold.data, item?.TotalRoom];
                totalRevenue.data = [...totalRevenue.data, item?.TotalRev];
            });
            let chartObj = {
                labels: labels,
                datasets: [totalRoomSold, totalRevenue],
            };
            setChartData(chartObj);
            setRevData(response?.data?.data);
            setLoading(false);
        }

        if (!response?.isValidate) {
            setChartData(null);
            setRevData(null);
            setLoading(false);
        }
    };

    useEffect(() => {
        if (api === 0) {
        } else {
            if (para?.asOfDate) {
                getRevData();
            }
        }
    }, [para?.asOfDate, selectedStatus]);

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: "top",
            },
            tooltip: {
                mode: "index",
                intersect: false,
                callbacks: {
                    label: function (context) {
                        let label = context.dataset.label || "";
                        let value = context.formattedValue;

                        if (label === "Total Room Sold") {
                            label += ": " + value;
                        } else {
                            label += ": $" + value;
                        }

                        return label;
                    },
                },
            },
            title: {
                display: true,
                text: "Revenue By MarketSegment",
            },
        },
    };

    Chart.register(
        CategoryScale,
        LinearScale,
        BarElement,
        Tooltip,
        Legend,
        PointElement,
        LineElement
    );

    const [tblids, settblids] = useState({
        tblRevByMarketSegment: commonService.GenerateGUID(),
    });

    const handleApply = () => {
        setSelectedStatus(selectedTempStatus);
        multiselectRef.current.hide();
    };
      
    const footerTemplate = () => (
        <div style={{ padding: "0.5rem", textAlign: "right" }}>
            <Button id={commonService.generateGlobalClickTrackerID("RevenueByMarketSegment", "apply", propertyCode)}
                onClick={handleApply}
            >Apply</Button>
        </div>
    );

    return (
        <div className="widget-container" style={{ position: "relative", padding: "0 5px" }}>
            {api !== 0 && (
                <div className="gap-1 widget-container-menu">
                    <Button className="heading-menu-btns" type="button" title="Send Mail">
                        <img id={commonService.generateGlobalClickTrackerID("RevenueByMarketSegment", "emailicon", propertyCode)}
                            src={emailIcon}
                            alt="emailIcon"
                            onClick={() => {
                                commonService.fnSendWidgetMail(
                                    tblids.tblRevByMarketSegment,
                                    "tblRev By MarketSegment",
                                    snapshotId,
                                    defaultAsOfDateFromRTK,
                                    "",
                                    para?.widgetId
                                );
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("RevenueByMarketSegment", "info", propertyCode)}
                            src={infoIcon}
                            alt="info"
                            onClick={() => {
                                widgetDetailRef.current = {
                                    widgetdetails: "",
                                    usernote: "",
                                    compName: compName?.ReservationAnalyticsChart,
                                    widgetId: para?.widgetId,
                                };
                                // setWidgetModal(true);
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("RevenueByMarketSegment", "menuicon", propertyCode)}
                            src={downloadIcon}
                            alt="menuIcon"
                            import={tblids.tblRevByMarketSegment}
                            onClick={() =>
                                commonService.fnExportInCSV(
                                    tblids.tblRevByMarketSegment,
                                    // "Day By Day Channel"
                                    `${para?.propertyCode}-tblRev By MarketSegment-${moment(
                                        new Date()
                                    ).format("MMDDYYYY")}`
                                )
                            }
                        />
                    </Button>
                </div>
            )}
            <table width={"100%"}>
                <tr>
                    <td style={{ verticalAlign: "top", paddingRight: "10px", width: "33%" }}>
                        <div className="ViewPropertySetupTable">
                            <div className="stripped__table">
                                <div className="table-responsive tblDynamicPickupSticky">
                                    <Table id={tblids.tblRevByMarketSegment} responsive>
                                        <thead className="tbl-header-sticky">
                                            <tr className="table-main-header-tr">
                                                <th>
                                                    <MultiSelect id={commonService.generateGlobalClickTrackerID("RevenueByMarketSegment", "marketsegment", propertyCode)}
                                                      filter
                                                      ref={multiselectRef}
                                                      placeholder="Select Revenue Status"
                                                      display="values"
                                                      selectedItemsLabel={`{0} Status Selected`}
                                                      maxSelectedLabels={0}
                                                      closeOnSelect={false}
                                                      value={selectedTempStatus}
                                                      options={initStatusList}
                                                      onChange={(e) => {
                                                          setSelectedTempStatus(e.value);
                                                      }}
                                                      panelFooterTemplate={footerTemplate}
                                                    />
                                                </th>
                                                <th className="text-center" colSpan={3}>
                                                    Revenue By MarketSegment
                                                </th>
                                            </tr>
                                            <tr className="table-main-header-tr">
                                                <th className="border_right text-center">
                                                    MarketSegment
                                                </th>
                                                <th className="border_right text-center">
                                                    Total Room Sold
                                                </th>
                                                <th className="text-end">Total Revenue</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ? (
                                                <tr style={{ height: "80px", position: "relative" }}>
                                                    <Loader />
                                                </tr>
                                            ) : revData ? (
                                                revData?.map((item) => {
                                                    return (
                                                        <tr className="shadowOnHover">
                                                            <td className="border_right text-center">
                                                                {item?.MarketSegment}
                                                            </td>
                                                            <td className="border_right text-center">
                                                                {commonService.formateRoom(item?.TotalRoom)}
                                                            </td>
                                                            <td className="text-end">
                                                                {commonService.formateAmount(item?.TotalRev)}
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan={3}>No Data Found</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td style={{ paddingLeft: "10px", verticalAlign: "top" }}>
                        {loading ? (
                            <Loader />
                        ) : chartData ? (
                            <Bar data={chartData} options={options} />
                        ) : (
                            <div>No Data Found</div>
                        )}
                    </td>
                </tr>
            </table>
        </div>
    );
};

export default RevenueByMarketSegment;
